import $ from 'jquery/dist/jquery';

window.jQuery = $;
window.$ = $;